import { render, staticRenderFns } from "./MasterProjectIdle.vue?vue&type=template&id=4905d8c2&scoped=true&"
import script from "./MasterProjectIdle.vue?vue&type=script&lang=js&"
export * from "./MasterProjectIdle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4905d8c2",
  null
  
)

export default component.exports